export interface IKeepingInTouchPreferences {
  keepInTouch?: boolean;
}
